import { Box, makeStyles, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";

const useStyle = makeStyles((theme) => ({
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.headerDefault,
  },
  cell: {
    cursor: "pointer",
    backgroundColor: theme.palette.background.headerDefault,
  },
  icon: {
    fontSize: "14px",
    color: theme.palette.text.secondary,
    marginLeft: "2px",
  },
  invisibleIcon: {
    visibility: "hidden",
    "&:hover": {
      visibility: "block",
    },
  },
}));

export default function TransactionHeader({ sortUpdate, sortType, sortKey }) {
  const cls = useStyle();
  const [hoverIndex, setHoverIndex] = useState(-1);
  const columns = [
    { id: "type", label: "Type", classes: cls.firstCell, style: { minWidth: 25 }, sort: undefined },
    { id: "datetime", label: "Date time", classes: cls.cell, style: { minWidth: 50 }, sort: "timestamp" },
    { id: "amount", label: "Amount(USD)", classes: cls.cell, style: { minWidth: 50 }, sort: "amount" },
    { id: "user", label: "User", classes: cls.cell, style: { minWidth: 130 }, sort: undefined },
    { id: "token", label: "Token", classes: cls.cell, style: { minWidth: 130 }, sort: undefined },
    { id: "transaction", label: "Transaction", classes: cls.cell, style: { minWidth: 140 }, sort: undefined },
  ];

  const onCellClick = (key) => {
    if (key) sortUpdate(key);
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((element, index) => {
          return (
            <TableCell
              key={element.id}
              className={element?.classes}
              style={element?.style}
              onClick={() => onCellClick(element.sort)}
              onMouseOver={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(-1)}
            >
              <Box display="flex" justifyContent="flex-start" alignItems="center">
                <Typography>{element.label}</Typography>
                {element.sort && (
                  <ArrowAnimationIcon
                    className={clsx(cls.icon, {
                      [cls.invisibleIcon]: element.sort !== sortKey && hoverIndex !== index,
                    })}
                    isTransform={element.sort === sortKey && sortType === "asc"}
                  />
                )}
              </Box>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
